<template>
  <BasicLayout :left="left" :middle="middle" :right="right">
    <template v-slot:right_view>
      <div class="h-outTabs">
        <div class='h100vh-100'>
          <ToolBar :addBtn="true" :delBtn="true" :editBtn="true" :refreshBtn="true" :keywordsInput="true" :exportBtn="true" :importBtn="true" @notice="notice" @keyword="keyword"></ToolBar>
          <div class="h100-40 h-scroll">
            <ejs-grid ref="grid" :allowPaging="true" :pageSettings="pageSettings" :height="screenHeight" :allowExcelExport='true'>
              <e-columns>
                <e-column type="checkbox" width="50" textAlign="center"></e-column>
                <e-column field="roleId" :visible="false"></e-column>
                <e-column field="roleName" :headerText="$t('Security.Role.name')" width="120" textAlign="Center" clipMode="EllipsisWithTooltip"></e-column>
                <e-column field="createTime" :headerText="$t('Security.Role.createTime')" :format="dateFormat" width="120" textAlign="Center" clipMode="EllipsisWithTooltip"></e-column>
                <e-column field="creator" :headerText="$t('Security.Role.creator')" width="120" textAlign="Center" clipMode="EllipsisWithTooltip"></e-column>
                <e-column field="description" :headerText="$t('Security.User.desc')" width="120" textAlign="Center" clipMode="EllipsisWithTooltip"></e-column>
              </e-columns>
            </ejs-grid>
            <ejs-pager ref="pager" :pageSize="pageSettings.pageSize" :pageCount="pageCount" @click="getRoleList"></ejs-pager>
          </div>
          <CustomDialog ref="addDialog" v-bind:element="addDialog.element" v-bind:styles="addDialog.styles">
            <template v-slot:dialog-content>
              <AddRole ref="addRole" v-bind:index="addRoleIndex" @childProps="getChildProps"></AddRole>
            </template>
          </CustomDialog>
          <CustomDialog ref="editDialog" v-bind:element="editDialog.element" v-bind:styles="editDialog.styles">
            <template v-slot:dialog-content>
              <EditRole ref="editRole" @childProps='getChildProps'></EditRole>
            </template>
          </CustomDialog>
           <CustomDialog ref='upload' :element='upload.element' :styles='upload.styles1'>
             <template v-slot:dialog-content>
              <AddDialog ref='addObj'></AddDialog>
            </template>
          </CustomDialog>
        </div>
      </div>
    </template>
  </BasicLayout>
</template>

<script>
import BasicLayout from "../../layouts/BasicLayout";
import CustomDialog from "../../components/common/CustomDialog";
import ToolBar from "../../components/security/roleManager/ToolBar";
import AddRole from "../../components/security/roleManager/AddRole";
import EditRole from "../../components/security/roleManager/EditRole";
import {ExcelExport} from '@syncfusion/ej2-vue-grids';

import AddDialog from '../../components/system/ConfigInEx/addDialog';
import bus from '../../components/system/bus.js';
import { EventBus } from '../../plugins/eventBus';
let fileName ="";

export default {
  name: "RoleManager",
  provide: {
    grid: [ExcelExport]
  },
  data() {
    return {
      left: { show: false, name: "" },
      middle: { show: false, name: "" },
      right: { show: true, crumb: `${this.$t('Security.securityManage')}`+'/' + `${this.$t('Security.authorityManage')}` + '/' + `${this.$t('Security.roleManage')}` },
      keyString: "",
      pageSettings: { pageSize: 15 },
      pageCount: 4,
      pageNo: 1,
      dateFormat: {
        type: 'date', format: 'yyyy/MM/dd HH:mm:ss'
      },
      addStatus: true,
      addDialog: {
        element: {
          // target: "#app",
          isClose: true,
          refName: "tip",
          buttonGroup: [
            {
              click: this.dialogHide,
              buttonModel: { content: `${this.$t("Common.cancel")}` }
            },
            {
              click: this.lastAdd,
              buttonModel: {
                content: `${this.$t("Common.previous")}`,
                cssClass: "h-security-display-none"
              }
            },
            {
              click: this.nextAdd,
              buttonModel: { content: `${this.$t("Common.next")}` }
            }
          ],
          title: `${this.$t("Security.addRole")}`
        },
        styles: {
          width: "810px",
          height: "750px",
          model: true,
          visible: false
        }
      },
      editDialog: {
        element: {
          target: "#app",
          isClose: true,
          refName: "tip",
          buttonGroup: [
            {
              click: this.dialogHide,
              buttonModel: {
                content: `${this.$t("Common.cancel")}`
              }
            },
            {
              click: this.editConfirm,
              buttonModel: { content: `${this.$t("Common.ok")}`, cssClass: 'primary-btn'}
            }
          ],
          title: `${this.$t("Security.editRole")}`
        },
        styles: {
          width: "810px",
          height: "750px",
          model: true,
          visible: false
        }
      },
      addRoleIndex: 0,
      addRoleProps: {}, // roleProps1, roleProps2, roleProps3
      upload: {
        styles: {
          width: '810px',
          height: '752px',
          model: true,
          visible: false
        },
        styles1: {
          width: '500px',
          height: '300px',
          model: true,
          visible: false
        },
        element: {
          refName: "detailLog",
          isClose: true,
          buttonGroup: [
            { click: this.dialogHide1, buttonModel: { content: this.$t('DataManagent.import') } },
          ],
          title: this.$t('Security.uploadFile')
        },
      },
      screenHeight: document.body.clientHeight - 240
    };
  },
  components: {
    BasicLayout,
    CustomDialog,
    ToolBar,
    AddRole,
    EditRole,
    AddDialog
  },
  methods: {
    notice(btn) {
      if (btn === "add") {
        this.addFunc();
      }
      if (btn === "del") {
        this.delFuncShow();
      }
      if (btn === "edit") {
        this.editFunc();
      }
      if (btn === "refresh") {
        this.refreshFunc();
      }
      if (btn === "query") {
        this.queryFunc();
      }
      if (btn === "exportGrid") {
        this.exportGrid();
      }
      if (btn === "importGrid") {
        this.importGrid();
      }
    },
    keyword(data) {
      this.keyString = data;
    },
    getRoleList() {
      const url = "/lte/ems/role/query";
      this.pageNo = this.$refs.pager.ej2Instances.currentPage;
      const params = {
        roleName: this.keyString,
        pageNo: this.pageNo,
        pageSize: this.pageSettings.pageSize
      };
      this.axios.get(url, { params }).then(response => {
        const result = response.data.result;
        let showRe = [];
        result.forEach(item => {
          let re = {};
          re.creator = item.creator;
          re.sysEnable = item.sysEnable;
          re.createTime = new Date(item.createTime);
          re.roleId = item.roleId;
          re.roleName = item.roleName;
          re.description = item.description;
          showRe.push(re);
        });
        this.$refs.grid.ej2Instances.dataSource = showRe;
        this.$refs.pager.ej2Instances.totalRecordsCount = response.data.totalCount;
      });
    },
    getRecord() {
      const result = this.$refs.grid.ej2Instances.getSelectedRecords();
      if (result == null || result == "") {
        this.$parent.showToast('warning',`${this.$t('Common.tips.noSelect')}`);
        return null;
      }
      return result;
    },
    addFunc() {
      this.addRoleIndex = 0;
      this.$refs.addRole.init();
      this.$refs.addDialog.show();
    },
    editFunc() {
      const record = this.getRecord();
      if (record == null) {
        return null;
      }
      if (record.length != 1) {
        this.$parent.showToast('warning',`${this.$t('Common.tips.onlyOneSelect')}`);
        return null;
      }
      if (record[0].sysEnable==0) {
        this.$parent.showToast('warning',`${this.$t('Security.EadminCannotModify')}`);
        return null;
      }
      const url = "/lte/ems/role/findOne";
      const params = {
        roleId: record[0].roleId
      };
      this.axios.get(url, { params }).then(response => {
        this.$refs.editRole.init(response.data);
        this.$refs.editDialog.show();
      });
    },
    delFuncShow(){
      const record = this.getRecord();
      if (record == null) {
        return null;
      }
      for (let i=0; i<record.length; i++) {
        if (record[i].sysEnable==0) {
          this.$parent.showToast('warning',`${this.$t('Security.EadminCannotDelete')}`);
          return null;
        }
      }
      this.$layer.confirm({
        msg: `${this.$t('Common.tips.confirmTip')}`,
        btn1: {
          msg: `${this.$t('Common.cancel')}`
        },
        btn2: {
          msg: this.$t('System.confirm'),
          func: this.delFunc

        }
      });
    },
    delFunc() {
      const url = "/lte/ems/role/delete";
      const params = [];
      let record = this.getRecord();
      record.forEach(item => {
        params.push(item.roleId);
      });
      let That = this;
      this.axios.post(url, params).then(response => {
        if (response.data) {
          That.$parent.showToast('success', `${this.$t('Common.tips.success')}`);
          That.getRoleList();
        } else {
          That.$parent.showToast('error', `${this.$t('Common.tips.failure')}`);
        }
      });
    },
    refreshFunc() {
      this.getRoleList();
    },
    queryFunc() {
      this.$refs.pager.ej2Instances.currentPage = 1;
      this.getRoleList();
    },
    dialogHide() {
      this.$refs.addDialog.clear();
      this.$refs.editDialog.clear();
      this.$refs.addDialog.close();
      this.$refs.editDialog.close();
      this.addRoleIndex = 0;
    },
    lastAdd() {
      if (this.addRoleIndex == 0) {
        return null;
      }
      this.addRoleIndex -= 1;
    },
    async nextAdd() {
      const roleName = this.addRoleProps['roleProps1'].roleName;
      if (roleName.trim() === '') {
        this.$parent.showToast('warning',`${this.$t('Security.roleNameNotNull')}`);
        return null;
      }
      if (this.addRoleIndex === 0) {
        const exist = await this.findRole();
        if (exist) {
          this.$parent.showToast('warning',`${this.$t('Security.roleNameExists')}`);
          return null;
        }
      }
      if (this.addRoleIndex == 2) {
        // 确定按钮，整合添加角色用户、分域、权限、组织架构
        this.addRole();
        this.addRoleIndex = 0;
        this.$refs.addDialog.clear();
        this.$refs.addDialog.close();
        return null;
      }
      this.addRoleIndex += 1;
    },
    async findRole() {
      const url = "/lte/ems/role/isExists";
      const params = { roleName: this.addRoleProps['roleProps1'].roleName };
      let result = null;
      await this.axios.get(url, { params }).then(response => {
        result = response.data;
      });
      return result;
    },
    copyDeep(templateData) {
      // templateData 是要复制的数组或对象，这样的数组或者对象就是指向新的地址的
      let returnData = JSON.parse(JSON.stringify(templateData));
      returnData.buttonGroup.forEach((item, index) => {
        item.click = templateData.buttonGroup[index].click;
      });
      return returnData;
    },
    getChildProps(data) {
      this.addRoleProps = data;
    },
    addRole() {
      if (this.addStatus) {
        this.addStatus = false;
        const url = '/lte/ems/role/add';
        const params = {
          roleName: this.addRoleProps['roleProps1'].roleName,
          description: this.addRoleProps['roleProps1'].description,
          groupIdList: this.addRoleProps['roleProps1'].selected, // List<String>
          nodeIdList: this.addRoleProps['roleProps2'].nodeDomain, // List<Integer>
          resourceIdList: this.addRoleProps['roleProps3'].permission,
          vpnIdList: this.addRoleProps['roleProps4'].vpnIdList,  // Map<Integer, List<String>>
          createTime: new Date().getTime(),
        }
        let That = this;
        this.axios.post(url, params).then(response => {
          const result = response.data;
          if (result) {
            That.$parent.showToast('success', `${this.$t('Common.tips.success')}`);
          } else {
            That.$parent.showToast('error', `${this.$t('Common.tips.failure')}`);
          }
          That.addStatus = true;
          this.getRoleList();
        });
      }
    },
    editConfirm() {
      const url = "/lte/ems/role/edit";
      const record = this.getRecord();
      const params = {
        roleName: this.addRoleProps['roleProps1'].roleName,
        description: this.addRoleProps['roleProps1'].description,
        groupIdList: this.addRoleProps['roleProps1'].selected,
        nodeIdList: this.addRoleProps['roleProps2'].nodeDomain,
        resourceIdList: this.addRoleProps['roleProps3'].permission,
        vpnIdList: this.addRoleProps['roleProps4'].vpnIdList,
        roleId: record[0].roleId,
        createTime: new Date().getTime()
      };
      this.$refs.editDialog.clear();
      this.$refs.editDialog.close();
      let That = this;
      this.axios.post(url, params).then(response => {
        const result = response.data;
        if (result) {
          That.$parent.showToast('success', `${this.$t('Common.tips.success')}`);
        } else {
          That.$parent.showToast('error', `${this.$t('Common.tips.failure')}`);
        }
        this.getRoleList();
      });
    },
    // 导入excel
    eventEmit(type, content) {
        EventBus.$emit('toast', {type: type, content: content})
        },
    dialogHide1() {
      if(fileName ==""||fileName == undefined){
          this.eventEmit('warning', this.$t('System.fileNotNull'));
           return;
      }
      let index = fileName.lastIndexOf(".");
      let fileType = fileName.substring(index+1).toLocaleLowerCase();

      if(fileType !='xlsx'){
        this.eventEmit('warning', this.$t('Security.fileTypeError'));
        return;
      }
    
      if(this.uploadProps.status == 1){
        this.$loading.showLoadding(this.$t('Software.progressing'));
        const url = '/lte/ems/role/importAuth';
        const param = {
          fileName: fileName
        };
        this.$axios.post(url, param).then(response => {
          this.$loading.hideLoadding();
          fileName = "";
          if (response && response.status === 200 && response.data.errorCode === 'SUCCESS') {
            EventBus.$emit('toast', {type: 'warn', content:this.$t('MCS.importSuccess') });
          } else {
            EventBus.$emit('toast', {type: 'error', content: response.data.errorString});
          }
        });
        this.$refs.upload.clear();
        this.$refs.upload.close();
      }else{
          this.$layer.confirm({
          title: this.$t('System.tip'),
          msg: this.$t('DeployManagement.tips_cancelUpload'),
          btn2: {
            msg: this.$t('System.confirm'),
            func: () => {
                this.$refs.upload.clear();
                this.$refs.upload.close();
            }
          },
          btn1: {
            msg: this.$t('System.cancel')
          }
        });
      }
    },

    
    getCheckedData(selectOnly) {
      const selectedRecords = this.$refs.grid.getSelectedRecords();
      if (selectedRecords.length < 1) {
        // this.$parent.showToast('warning',`${this.$t('Alarm.no_checked')}`);
        return false;
      }
      return selectedRecords;
    },
    exportGrid(){
      const rows = this.getCheckedData(true);
          // if(rows.length ===0){
          //   this.$parent.showToast('warning',  `${this.$t('Alarm.no_checked')}`);
          // }
          this.exportData(rows);
    },
    exportData(rows){
      const param = {
        "path":"/home/",
        "fileNames":"用户管理.xlsx"
      }
      //  const data = JSON.parse(param);
      axios({
        method: 'post',
        url: '/lte/ems/role/export',
        data: param,
        responseType: 'blob'
        }).then(response => {
        const link = document.createElement('a');
        const blob = new Blob([response.data], { type: 'application/vnd.ms-excel' });
        let fileNames = response.headers['content-disposition'] //获取到Content-Disposition;filename
        console.log("fileNames",fileNames)
        let regFileNames = fileNames.match(/=(.*)$/)[1]; //文件名称  截取=后面的文件名称

        link.style.display = 'none';
        link.href = URL.createObjectURL(blob);
        link.setAttribute("download", regFileNames);
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        })
      },
    exportGrid1(){
      const This = this;
      const checkedData = This.getCheckedData();
      if (checkedData) {
        const exportProperties = {
          fileName: `${this.$t('Security.roleManage')}.xlsx`,
          dataSource: checkedData
        };
        This.$refs.grid.getColumns()[0].visible = false;
        This.$refs.grid.excelExport(exportProperties);
      }
    },
    importGrid(){
      this.uploadProps = {status: 1};
      this.$refs.upload.show();
    },
  },
    beforeDestroy() {
    bus.$off('selectNeData');
    bus.$off('fileName');
  },
  mounted() {
    fileName ="";
    console.log("=====fileName===",fileName);
    bus.$on('selectNeData', (neNode) => {
      checkData = neNode;
    });

     bus.$on('fileName', (neNode) => {
           console.log("=====neNode===",neNode);
       fileName = neNode;
    });
    this.getRoleList();
    let That = this;
    window.onresize = () => {
      return (() => {
        That.screenHeight = document.body.clientHeight - 240;
      })()
    }
  },
  watch: {
    addRoleIndex() {
      const tempButton = this.copyDeep(this.addDialog.element);
      if (this.addRoleIndex === 2) {
        tempButton.buttonGroup[2].buttonModel.content = `${this.$t('Common.ok')}`;
        tempButton.buttonGroup[2].buttonModel.cssClass = 'primary-btn';
      } else {
        tempButton.buttonGroup[2].buttonModel.content = `${this.$t('Common.next')}`;
        tempButton.buttonGroup[2].buttonModel.cssClass = '';
      }
      if (this.addRoleIndex === 0) {
        tempButton.buttonGroup[1].buttonModel.cssClass = "h-security-display-none";
      } else {
        tempButton.buttonGroup[1].buttonModel.cssClass = "h-security-display-block";
      }
      this.addDialog.element = tempButton;
    },
    screenHeight(val) {
      this.screenHeight = val;
    }
  }
};
</script>
